export enum AnalysisFieldState {
  MATCHES = 'matches',
  EXISTS = 'exists',
  NEW = 'new',
}

export enum AnalysisFieldIcon {
  CHECK = 'check',
  EDIT = 'edit',
  SAVE = 'save',
}

export interface AnalysisFieldInfo {
  state: AnalysisFieldState;
  tooltip: string;
  icon: AnalysisFieldIcon;
  disabled: boolean;
}
